import {
  INITIAL_IMPORT_ACTIVE_POLL_INTERVAL_MS,
  INITIAL_IMPORT_IDLE_POLL_INTERVAL_MS,
} from '../config/initialImport';

export const shouldContinueInitialImportPolling = ({
  initialImportExperienceActive = false,
  onboardingImportStartedAt = null,
  canEnterDashboard = false,
  reviewReady = false,
  failed = false,
} = {}) => (
  initialImportExperienceActive || (
    Boolean(onboardingImportStartedAt)
    && canEnterDashboard
    && !reviewReady
    && failed !== true
  )
);

export const resolveInitialImportPollInterval = ({
  shouldContinuePolling = false,
} = {}) => (
  shouldContinuePolling
    ? INITIAL_IMPORT_ACTIVE_POLL_INTERVAL_MS
    : INITIAL_IMPORT_IDLE_POLL_INTERVAL_MS
);
